/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonPlace,
    JsonPlaceFromJSON,
    JsonPlaceFromJSONTyped,
    JsonPlaceToJSON,
} from './JsonPlace';

/**
 * 
 * @export
 * @interface ApiResultOfJsonPlace
 */
export interface ApiResultOfJsonPlace {
    /**
     * 
     * @type {JsonPlace}
     * @memberof ApiResultOfJsonPlace
     */
    data?: JsonPlace;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonPlace
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonPlace
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonPlace
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonPlace
     */
    result?: ApiResultOfJsonPlaceResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonPlaceResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonPlaceFromJSON(json: any): ApiResultOfJsonPlace {
    return ApiResultOfJsonPlaceFromJSONTyped(json, false);
}

export function ApiResultOfJsonPlaceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonPlace {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonPlaceFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonPlaceToJSON(value?: ApiResultOfJsonPlace | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonPlaceToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

